import { createContext, useContext, useEffect, useState } from "react";
import { t as translate, RTL_LOCALES, localeTag, MARKETS } from "./index";

const LocaleCtx = createContext({
  locale: "en",
  lang: "en",
  dir: "ltr",
  t: (k, f) => f ?? k,
  setLang: () => {},
  market: null,
});

// Country markets (Africa Wave 1): the ROUTE is a country (e.g. /ma) and
// `lang` is the active interface language — primarily the market's own
// language, switchable in place when the market offers several (Mauritius
// EN⇄FR) without leaving the country route.
export const LocaleProvider = ({ locale, children }) => {
  const market = MARKETS[locale] || null;
  const [lang, setLang] = useState(market?.lang || locale);
  useEffect(() => {
    setLang(MARKETS[locale]?.lang || locale);
  }, [locale]);
  const dir = RTL_LOCALES.includes(lang) ? "rtl" : "ltr";
  useEffect(() => {
    document.documentElement.lang = localeTag(locale, lang);
    document.documentElement.dir = dir;
  }, [locale, lang, dir]);
  const t = (key, fallback) => translate(locale, key, fallback, lang);
  return (
    <LocaleCtx.Provider value={{ locale, lang, setLang, market, dir, t }}>
      {children}
    </LocaleCtx.Provider>
  );
};

export const useLocale = () => useContext(LocaleCtx);
